export function openSupportMenu(): void {
  window.requestAnimationFrame(() =>
    (
      document.querySelector(
        '[data-behavior="sf-help-menu"]'
      ) as HTMLAnchorElement
    )?.click()
  )
}
